export type BonusIcon = 'timer' | 'message' | 'users' | 'flame' | 'lightbulb'

/** Region of the product mockup showing this bonus cover, as fractions of the image (0–1). */
export interface CoverCrop {
  x: number
  y: number
  w: number
  h: number
}

export interface Bonus {
  number: string
  title: string
  intro?: string
  /** Label shown above the item chips. */
  listLabel?: string
  items?: string[]
  /** Optional label in front of the closing lines (e.g. "Result:"). */
  closingLabel?: string
  closing: string[]
  /** Label color from the bonus covers in the mockup. */
  color: string
  icon: BonusIcon
  /** Where the cover sits inside the product mockup. */
  crop: CoverCrop
}

export const bonuses: Bonus[] = [
  {
    number: '1',
    title: '5-Minute Futsal Practice Builder™',
    intro:
      'Answer a few key questions and quickly build a clear futsal session structure.',
    listLabel: 'Choose:',
    items: [
      'Main objective',
      'Player level',
      'Available time',
      'Player number',
      'Equipment',
      'Technical or tactical priority',
    ],
    closingLabel: 'Result:',
    closing: ['A simple structure you can organize in minutes.'],
    color: '#3b82f6',
    icon: 'timer',
    crop: { x: 0.04, y: 0.69, w: 0.205, h: 0.27 },
  },
  {
    number: '2',
    title: 'Futsal Coaching Cues Library™',
    listLabel: 'Short, useful coaching cues for:',
    items: [
      'First touch',
      'Passing',
      'Movement',
      '1v1',
      'Pressing',
      'Defending',
      'Transitions',
      'Finishing',
      'Communication',
    ],
    closing: ['Less talking.', 'Clearer corrections.', 'More repetitions.'],
    color: '#a855f7',
    icon: 'message',
    crop: { x: 0.235, y: 0.69, w: 0.19, h: 0.27 },
  },
  {
    number: '3',
    title: 'Mixed-Level Adaptation Kit™',
    intro: 'Turn one exercise into different levels.',
    listLabel: 'Make it:',
    items: [
      'Easier',
      'Harder',
      'Faster',
      'More controlled',
      'More competitive',
      'More decision-based',
      'More opposed',
    ],
    closing: ['Use the same core drill without losing half the group.'],
    color: '#14b8a6',
    icon: 'users',
    crop: { x: 0.42, y: 0.69, w: 0.185, h: 0.27 },
  },
  {
    number: '4',
    title: 'Ready-to-Run Futsal Warm-Ups™',
    intro:
      'Structured futsal warm-ups that prepare players for the real objective of the session.',
    closing: ['No random jogging.', 'No wasted opening minutes.', 'Start with purpose.'],
    color: '#ef4444',
    icon: 'flame',
    crop: { x: 0.61, y: 0.69, w: 0.185, h: 0.27 },
  },
  {
    number: '5',
    title: 'Drill Fixer™',
    intro: 'What do you change when a drill is not working?',
    listLabel: 'Use quick adjustments for:',
    items: [
      'Too easy',
      'Too difficult',
      'Too much waiting',
      'Poor spacing',
      'Players crowding the ball',
      'Low intensity',
      'Too many touches',
      'Too much confusion',
    ],
    closing: ['Change one variable at a time instead of replacing the entire drill.'],
    color: '#8b5cf6',
    icon: 'lightbulb',
    crop: { x: 0.795, y: 0.69, w: 0.2, h: 0.27 },
  },
]
